export const getPricePlans = state => state.pricePlansReducer.pricePlans;
export const getPricePlansIsFetching = state => state.pricePlansReducer.isFetching;
export const getPricePlansError = state => state.pricePlansReducer.error;
